import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { NumberParam, useQueryParam } from './useQueryParams'

function usePage(): [number, (page: number) => void] {
  let [page, setPage] = useQueryParam<number | undefined>('page', NumberParam)
  const navigate = useNavigate()
  const location = useLocation()

  const positivePagesOnly = page && page >= 1 ? page : 1

  // if a user tries to set a page to anything < 1, set the page to 1 and update the url
  useEffect(() => {
    if (page !== undefined && page < 1) {
      const searchParams = new URLSearchParams(location.search)
      searchParams.set('page', '1')
      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true,
      })
    }
  }, [page, navigate, location])
  const setNewPage = (newPage: number) => {
    if (newPage >= 1) {
      setPage(newPage)
    } else {
      setPage(undefined)
    }
  }

  return [positivePagesOnly, setNewPage]
}

export default usePage
